/**
 * description: 微博转发
 * author: Qian.qianchen 2018-11-23
 */
'use strict';
angular.module('weiboRepostModule', []).controller('weiboRepostCtrl', [
    '$scope',
    '$stateParams',
    '$modalInstance',
    'item',
    'channelModule',
    'editingCenterService',
    '$q',
    '$validation',
    'sensitiveWordCheckService',
    'trsHttpService',
    '$timeout',
    'modalDialog',
    'editcenterRightsService',
    'weiboApiParams',
    'weiboApiService',
    function(
        $scope,
        $stateParams,
        $modalInstance,
        item,
        channelModule,
        editingCenterService,
        $q,
        $validation,
        sensitiveWordCheckService,
        trsHttpService,
        $timeout,
        modalDialog,
        editcenterRightsService,
        weiboApiParams,
        weiboApiService
    ) {
        initStatus();
        getZhenshenRight();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                params: {
                    AccountIds: $stateParams.wbchannelid,
                    MicroContentId: item.id,
                    Content: '',
                    SCMGroupId: 1,
                    modulename: channelModule,
                    ScheduleTime: '',
                    DocGenre: '',
                    IsNoPayment: 1,
                    fgd_editinfo: '',
                    fgd_authinfo: '',
                    isContainSensitiveWords: '0',
                },
                emojiShow: false,
                setTimeShow: false,
                isCheckSensitiveWords: false,
                isInitFdg: false,
                channelId: $stateParams.wbchannelid,
            };
            $scope.data = {
                content: '',
            };
        }

        /**
         * [getZhenshenRight description] 获取用户政审权限
         * @return {[type]} [description]
         */
        function getZhenshenRight() {
            editcenterRightsService.initWeiboListBtn('microblog.daishen', $scope.status.channelId).then(function(rights) {
                $scope.status.zhenshenRight = rights['microblog.daishen.zhengshen'];
            });
        }

        /**
         * [dateFormat description] 日期整理
         * @param  {[Date]} date    [description] 日期
         * @param  {[String]} getType [description] 需要的时间段
         * @return {[type]}         [description]
         */
        function dateFormat(date, getType) {
            if (angular.isDefined(date) && date != '') {
                var d = new Date(date);
                if (getType === 'date') {
                    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                } else {
                    return d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
                }
            } else {
                return '';
            }
        }

        /**
         * [initFdgInfo description] 发稿单默认信息
         * @return {[type]} [description]
         */
        function initFdgInfo(params) {
            var deferred = $q.defer();
            if (!$scope.status.isInitFdg) {
                getCurrentLoginUser().then(function(data) {
                    data[0].TYPE = '21';
                    params.fgd_authinfo = JSON.stringify(data);
                    params.fgd_editinfo = '[]';
                    params.DocGenre = JSON.stringify({ name: '无体裁', value: '无体裁' });
                    deferred.resolve(params);
                });
            } else {
                deferred.resolve(params);
            }
            return deferred.promise;
        }

        /**
         * [getCurrentLoginUser description] 获取当前登录用户信息
         * @return {[type]} [description]
         */
        function getCurrentLoginUser() {
            var deferred = $q.defer();
            var userParams = {
                serviceid: 'mlf_extuser',
                methodname: 'findUserInfo',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, 'post').then(function(data) {
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [clearDateTime description] 清除时间
         * @param  {[string]} type [description] 时间/日期
         * @return {[type]}      [description]
         */
        $scope.clearDateTime = function(type) {
            if (type == 'date') {
                $scope.status.signDate = '';
            } else {
                $scope.status.signTime = '';
            }
        };

        /**
         * [mouseEnter description] 时间控件鼠标进入方法
         * @param  {[string]} type [description] 时间/日期
         * @return {[type]}      [description]
         */
        $scope.mouseEnter = function(type) {
            if (type == 'date') {
                $scope.status.dateClear = $scope.status.signDate != '' ? true : false;
                $('.date_input').css({ color: '#000' });
            } else {
                $scope.status.timeClear = $scope.status.signTime != '' ? true : false;
            }
        };

        /**
         * [mouseOut description] 时间控件鼠标移除方法
         * @param  {[string]} type [description] 时间/日期
         * @return {[type]}      [description]
         */
        $scope.mouseOut = function(type) {
            if (type == 'date') {
                $scope.status.dateClear = false;
            } else {
                $scope.status.timeClear = false;
            }
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [addEmoji 添加表情]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.addEmoji = function(item) {
            var $t = document.getElementById('input_content');
            var startPos = $t.selectionStart;
            var endPos = $t.selectionEnd;
            $scope.data.content =
                $scope.data.content.substring(0, startPos) + item.value + $scope.data.content.substring(endPos, $scope.data.content.length);

            $timeout(function() {
                $t.selectionStart = $t.selectionEnd = startPos + item.value.length;
                $t.focus();
            });
        };

        /**
         * [setSheet 发稿单设置]
         *
         * @return  {[type]}  [return description]
         */
        $scope.setSheet = function() {
            var fdgInfo;
            if ($scope.status.isInitFdg) {
                fdgInfo = {
                    DocGenre: $scope.status.params.DocGenre,
                    fgd_editinfo: $scope.status.params.fgd_editinfo,
                    fgd_authinfo: $scope.status.params.fgd_authinfo,
                    ISNOPAYMENT: $scope.status.params.IsNoPayment,
                };
            }
            editingCenterService.draftListForFgd(
                0,
                function(params) {
                    $scope.status.isInitFdg = true;
                    $scope.status.params.DocGenre = params.DOCGENRE;
                    $scope.status.params.IsNoPayment = params.ISNOPAYMENT;
                    $scope.status.params.fgd_authinfo = params.FGD_AUTHINFO;
                    $scope.status.params.fgd_editinfo = params.FGD_EDITINFO;
                },
                fdgInfo
            );
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var deferred = $q.defer();
            $scope.contentForm.$pending = {};
            let params = angular.extend({}, weiboApiParams.rePostParams, $scope.status.params);
            $validation.validate($scope.contentForm).success(function() {
                params.Content = $scope.data.content;
                params.ScheduleTime = $scope.status.setTimeShow
                    ? dateFormat($scope.status.signDate, 'date') + ' ' + dateFormat($scope.status.signTime, 'time')
                    : ' ';
                initFdgInfo(params).then(function(params) {
                    sensitiveWordCheckService.sensitiveWords($scope).then(
                        function(sensitiveWords) {
                            params.isContainSensitiveWords = !!sensitiveWords.length ? 1 : 0; 
                            if (!!sensitiveWords.length && params.ScheduleTime !== ' ') {
                                $scope.loadingPromise = weiboApiService.repost(params).then(
                                    function(result) {
                                        deferred.resolve(result);
                                        modalDialog.alertType(
                                            '该微博定时转发失败！',
                                            '该微博包含敏感词,不允许定时转发！',
                                            'error',
                                            'confirm',
                                            function() {}
                                        );
                                    },
                                    function(result) {
                                        modalDialog.alertType(result.DETAIL, '', 'error', 'confirm', function() {});
                                    }
                                );
                            } else if (!!sensitiveWords.length && $scope.status.params.ScheduleTime == ' ') {
                                modalDialog.alertType(
                                    '检测到敏感词，是否继续转发？',
                                    $scope.status.zhenshenRight ? '' : '注：如点击确定，稿件将等待敏感词审核完成之后才会正式转发。',
                                    'warning',
                                    true,
                                    function() {
                                        $scope.loadingPromise = weiboApiService.repost(params).then(
                                            function(result) {
                                                deferred.resolve(result);
                                                $modalInstance.close($scope.status.params.ScheduleTime != ' ' ? 'successTimeRepost' : 'success');
                                            },
                                            function(result) {
                                                modalDialog.alertType(result.DETAIL, '', 'error', 'confirm', function() {});
                                            }
                                        );
                                    },
                                    function() {}
                                );
                            } else {
                                $scope.loadingPromise = weiboApiService.repost(params).then(
                                    function(result) {
                                        deferred.resolve(result);
                                        $modalInstance.close($scope.status.params.ScheduleTime != ' ' ? 'successTimeRepost' : 'success');
                                    },
                                    function(result) {
                                        modalDialog.alertType(result.DETAIL, '', 'error', 'confirm', function() {});
                                    }
                                );
                            }
                        },
                        function() {
                            deferred.reject();
                        }
                    );
                });
            });
            return deferred.promise;
        };
    },
]);
